import React from "react";
import { TestimonialBlock } from "../components/testimonial";
import { Link } from "react-router-dom";
import FaceJeff from "@/assets/images/markus-r.png";
import Hero from "@/assets/images/platform-hero.jpg";

/* Container */
const Container: React.FC<React.PropsWithChildren<{ className?: string }>> = ({
  className = "",
  children,
}) => (
  <div className={`mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8 ${className}`}>
    {children}
  </div>
);

export default function ServicesPlatformPage() {
  return (
    <section className="py-14 text-white">
      <Container>
        {/* Back link */}
        <Link
          to="/services"
          className="inline-flex items-center text-sm text-white/60 hover:text-white mb-6 transition"
        >
          ← Services
        </Link>

        {/* Header */}
        <div className="mb-12">
          <h2 className="font-display text-4xl md:text-7xl mb-6">
            Accelerate delivery. Unlock innovation
          </h2>
          <p className="text-lg md:text-2xl leading-7 md:leading-9 text-white/60">
            Beyond Backstage - designing and building developer platforms,
            enabling organisations to build and ship faster and with more
            confidence.
          </p>
        </div>

        {/* Two-column meta block */}
        <div className="flex flex-col md:flex-row gap-10 md:gap-40 text-white/60 mb-10">
          {/* Left column */}
          <div className="space-y-6">
            <div>
              <h3 className="font-semibold text-white">Clients</h3>
              <ul className="space-y-1">
                <li>IKEA IT</li>
                <li>Länsförsäkringar</li>
              </ul>
            </div>
          </div>

          {/* Right column */}
          <div className="space-y-6">
            <div>
              <h3 className="font-semibold text-white">What we did</h3>
              <ul className="space-y-1">
                <li>
                  Driving and building the Developer Portal and Platform
                  initiative
                </li>
                <li>
                  Advisory, enablement and hands-on work building Developer
                  Platform capabilities
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Image */}
        <img src={Hero} alt="Developer platform work" className="mb-10" />

        {/* Body copy */}
        <div className="mb-8 text-lg md:text-2xl leading-7 md:leading-9 leading-relaxed w-full md:w-3/4 text-white/80">
          <p>
            We do client work at mid- and large-sized companies designing and
            building developer platforms that let product teams keep the right
            focus — instead of spending time wiring up infrastructure or
            patching tooling gaps. <br />
            Think Backstage, golden paths, abstractions, and declarative intents
            instead of one-off scripts and tribal knowledge.
          </p>
          <p className="mt-4">
            With self-serve, organisation-aligned and compliant workflows, the
            platform reduces developers cognitive load, and boosts developer
            efficiency — making the company ship faster and with more
            confidence.
          </p>
        </div>

        {/* Testimonial 
        <TestimonialBlock
          quote="BoldBrave are one of the rare teams that consistently deliver — fast, without compromising quality. They bring clarity, calm, and real momentum to complex digital work."
          author="Magnus Frennmark"
          role="CEO Fitness24Seven"
          avatar={FaceJeff}
        />
        */}
      </Container>
    </section>
  );
}
